function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (!document._loadCallbacks) {
    document._loadCallbacks = [];
  }

  if (document.readyState === 'complete') {
    return cb();
  }

  document._loadCallbacks.push(cb);
}

export default load;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/util/load.js
// module id = 8qvQ
// module chunks = 0